import {
    apiRequest,
    seminarList,
    seminarListAdmin,
    seminarInactive,
    seminarActive,
    seminarDetail
} from "../../../../../../services/adapters/kepegawaian/seminarService"

class DataTableRepository {

    fetchRowTableAdmin = async (query, cancelToken) => {
        return await apiRequest("get", seminarListAdmin, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", seminarList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", seminarInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", seminarActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", seminarDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

}

export default DataTableRepository